// TODO: Удлить, заменить на scrollToElement
/**
 * @deprecated Удлить, заменить на scrollToElement
 */
export const scrollIntoView = (element, options = { behavior: 'smooth', block: 'center', offsetSelector: '' }) => {
  if (!element) return;

  let $el = element;

  if (typeof element === 'string') {
    $el = document.querySelector(element);
  } else if (element.$el) {
    $el = element.$el;
  }

  if (!$el || typeof $el?.scrollIntoView !== 'function') return;

  if (options.offsetSelector) {
    // откручиваем выше, с учетом плавающей шапки
    const offsetElement = document.querySelector(options.offsetSelector);
    $el.style = `scroll-margin-top: ${offsetElement.offsetHeight}px`;
  }

  $el.scrollIntoView(options);
};

export default {
  install: (app) => {
    if ((typeof window === 'undefined')) return;

    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$scrollIntoView = scrollIntoView;
  },
};
